import React from "react";
import "./LoadMore.scss";

export default function LoadMore({ children }) {
  return <>{children}</>;
}
